
import Vue from 'vue'
import { RouterUtil } from '~/utils/router'

export default Vue.extend({
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  created() {
    // 遷移ログ
    this.$logger.logActionId('ACT-TA-00009', 'SCID_CA_CM_020')
  },
  methods: {
    backToPrevious() {
      RouterUtil.backToPrevious(this.$router)
    },
  },
})
